// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__27r63","content":"styles_content__33gAw","checkbox":"styles_checkbox__yFvwU","checkboxLabel":"styles_checkboxLabel__2nFAw"};